// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"0b229831","239":"96461c76","338":"dd8b1e5e","451":"ab5942de","453":"870fca90","732":"9d6f7a12","977":"7a8d0523"}[chunkId] + ".chunk.js";
};